export interface MenuItem {
  id: number;
  name: string;
  description: string;
  price: number;
  image: string;
  category: string;
}

export interface Store {
  id: string;
  name: string;
  cuisine: string;
  rating: number;
  reviewCount: number;
  deliveryTime: string;
  deliveryFee: number;
  image: string;
  isOpen: boolean;
  description: string;
  address: string;
  phone: string;
  menuItems: MenuItem[];
}

export const stores: Store[] = [
  {
    id: "mnandi-braai",
    name: "Mnandi Braai",
    cuisine: "South African Braai",
    rating: 4.8,
    reviewCount: 542,
    deliveryTime: "30-45 min",
    deliveryFee: 20,
    image: "/images/mnandi-braai-storefront.webp",
    isOpen: true,
    description: "Authentic South African braai and grills. Taste So Much More with our flame-grilled specialties.",
    address: "Johannesburg, South Africa",
    phone: "+27 XX XXX XXXX",
    menuItems: [
      {
        id: 1,
        name: "Mnandi One",
        description: "Short Ribs, Wings, Chips, Chakalaka, Cold-drink(330ml)",
        price: 126,
        image: "https://www.mnandibraai.co.za/assets/img/menu/shortrib-wing.jpg",
        category: "Medium Meals"
      },
      {
        id: 2,
        name: "Mnandi Feast",
        description: "1/2 Chicken, 2x Wors, 2x Short Ribs, Medium Chips, Rolls/Dombolo/Pap/Ting, Chakalaka/Spinach/Atchaar",
        price: 234.60,
        image: "https://www.mnandibraai.co.za/assets/img/menu/mnandi-feast.jpg",
        category: "Large Meals"
      },
      {
        id: 3,
        name: "Can't Put It Down",
        description: "Wors and Chips",
        price: 49.90,
        image: "https://www.mnandibraai.co.za/assets/img/menu/wors-chips.jpg",
        category: "Medium Meals"
      },
      {
        id: 4,
        name: "Mnandi Family",
        description: "Full Chicken, 4x wors, 4 Short Ribs, Large Chips, 1 Salad, 2L Cold drink, 4x Rolls/Dombolo/Pap/Ting, 4x Gravy, Chakalaka, Atchaar",
        price: 427.30,
        image: "https://www.mnandibraai.co.za/assets/img/menu/mnandi-family2.jpg",
        category: "Large Meals"
      },
      {
        id: 5,
        name: "4 Wings Meal",
        description: "4 Chicken wings and Chips",
        price: 99.40,
        image: "https://www.mnandibraai.co.za/assets/img/menu/mnadi-wings.jpg",
        category: "Medium Meals"
      },
      {
        id: 6,
        name: "Mnandi Stew",
        description: "Beef Stew & Pap/Dombolo/Ting & Chakalaka/Spinach/Atchaar",
        price: 79.70,
        image: "https://www.mnandibraai.co.za/assets/img/menu/beef-stew.jpg",
        category: "Medium Meals"
      },
      {
        id: 7,
        name: "Chicken Stew",
        description: "Chicken Stew & Pap/Dombolo/Ting & Chakalaka/Spinach/Atchaar",
        price: 59.90,
        image: "https://www.mnandibraai.co.za/assets/img/menu/chicken-stew.jpg",
        category: "Medium Meals"
      },
      {
        id: 8,
        name: "1/4 Chicken Meal",
        description: "Quarter Chicken and Chips",
        price: 64.90,
        image: "https://www.mnandibraai.co.za/assets/img/menu/quater-chicken1.jpg",
        category: "Medium Meals"
      },
      {
        id: 9,
        name: "1/2 Chicken Meal",
        description: "Half-Chicken and Medium Chips",
        price: 117.90,
        image: "https://www.mnandibraai.co.za/assets/img/menu/quater-chicken.jpg",
        category: "Large Meals"
      },
      {
        id: 10,
        name: "Full Chicken Meal",
        description: "Full-Chicken and Large Chips",
        price: 179.90,
        image: "https://www.mnandibraai.co.za/assets/img/menu/quater-chicken.jpg",
        category: "Large Meals"
      },
      {
        id: 11,
        name: "Livers Meal",
        description: "Chicken Livers and Pap/Dombolo/Ting",
        price: 59.90,
        image: "https://www.mnandibraai.co.za/assets/img/menu/chicken-liver.jpg",
        category: "Medium Meals"
      },
      {
        id: 12,
        name: "Mnandi Burger",
        description: "Juicy Beef Patty with delicious toppings",
        price: 69.50,
        image: "https://www.mnandibraai.co.za/assets/img/menu/mnandi-burger-single.jpg",
        category: "Burgers"
      },
      {
        id: 13,
        name: "Mnandi Twin Burger",
        description: "2 Juicy Beef Patties with delicious toppings",
        price: 86.90,
        image: "https://www.mnandibraai.co.za/assets/img/menu/mnandi-burger-double.jpg",
        category: "Burgers"
      },
      {
        id: 14,
        name: "Mnandi Cheese Burger",
        description: "Juicy Beef Patty and melting cheese with delicious toppings",
        price: 73.30,
        image: "https://www.mnandibraai.co.za/assets/img/menu/mnandi-cheese-burger-single.jpg",
        category: "Burgers"
      },
      {
        id: 15,
        name: "Mnandi Twin Cheese Burger",
        description: "2 Juicy Beef Patties and melting cheese with delicious toppings",
        price: 97.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/mnandi-cheese-burger-double.jpg",
        category: "Burgers"
      },
      {
        id: 16,
        name: "Mnandi Kids Meal",
        description: "1 Full Wing, Wors, Chips & 250ml Juice",
        price: 55.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/kiddies-meals.jpg",
        category: "Kiddo Meals"
      },
      {
        id: 17,
        name: "Kiddo Burger Meal",
        description: "Kiddies Roll, Juicy Patty, Chips, & 250ml Juice",
        price: 65.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/kiddies-meals.jpg",
        category: "Kiddo Meals"
      },
      {
        id: 18,
        name: "Kiddo Cheese Burger",
        description: "Kiddies Roll, Juicy Patty, Cheese, Chips, & 250ml Juice",
        price: 75.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/kiddies-meals.jpg",
        category: "Kiddo Meals"
      },
      {
        id: 19,
        name: "Mnandi Chips",
        description: "Small (R15), Medium (R18), Large (R24)",
        price: 15.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/chips.jpg",
        category: "Sides"
      },
      {
        id: 20,
        name: "Side Pap",
        description: "Traditional maize porridge",
        price: 12.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/sides1.jpg",
        category: "Sides"
      },
      {
        id: 21,
        name: "Ting",
        description: "Fermented maize meal",
        price: 12.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/sides1.jpg",
        category: "Sides"
      },
      {
        id: 22,
        name: "Dombolo",
        description: "Traditional steamed bread",
        price: 15.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/sides1.jpg",
        category: "Sides"
      },
      {
        id: 23,
        name: "Chicken Salad",
        description: "Fresh salad with grilled chicken",
        price: 40.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/salads.jpg",
        category: "Sides"
      },
      {
        id: 24,
        name: "Green Salad",
        description: "Fresh garden salad",
        price: 40.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/salads.jpg",
        category: "Sides"
      },
      {
        id: 25,
        name: "Spinach",
        description: "Seasoned spinach side",
        price: 15.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/sides.jpg",
        category: "Sides"
      },
      {
        id: 26,
        name: "Chakalaka",
        description: "Spicy vegetable relish",
        price: 20.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/sides.jpg",
        category: "Sides"
      },
      {
        id: 27,
        name: "Atchar",
        description: "Spicy pickled condiment",
        price: 15.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/sides.jpg",
        category: "Sides"
      },
      {
        id: 28,
        name: "Gravy",
        description: "Rich meat gravy",
        price: 20.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/sides.jpg",
        category: "Sides"
      }
    ]
  },
  {
    id: "kasi-street-kitchen",
    name: "Kasi Street Kitchen",
    cuisine: "South African Street Food",
    rating: 4.7,
    reviewCount: 389,
    deliveryTime: "20-30 min",
    deliveryFee: 15,
    image: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=400&fm=webp&q=50",
    isOpen: true,
    description: "Authentic township flavors and street food favorites. From bunny chow to kota, we bring the streets to your door.",
    address: "Soweto, Johannesburg",
    phone: "+27 XX XXX XXXX",
    menuItems: [
      {
        id: 101,
        name: "Bunny Chow - Chicken Curry",
        description: "Quarter loaf hollowed out and filled with rich chicken curry",
        price: 55.00,
        image: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400",
        category: "Bunny Chow"
      },
      {
        id: 102,
        name: "Bunny Chow - Mutton Curry",
        description: "Quarter loaf with slow-cooked mutton curry",
        price: 65.00,
        image: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400",
        category: "Bunny Chow"
      },
      {
        id: 103,
        name: "Bunny Chow - Bean Curry",
        description: "Vegetarian quarter loaf with spiced bean curry",
        price: 45.00,
        image: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400",
        category: "Bunny Chow"
      },
      {
        id: 104,
        name: "Kota - Original",
        description: "Quarter loaf with chips, polony, cheese, egg & sauce",
        price: 50.00,
        image: "https://images.unsplash.com/photo-1586190848861-99aa4a171e90?w=400",
        category: "Kota"
      },
      {
        id: 105,
        name: "Kota - Russian",
        description: "Quarter loaf with chips, Russian sausage, cheese & sauce",
        price: 60.00,
        image: "https://images.unsplash.com/photo-1586190848861-99aa4a171e90?w=400",
        category: "Kota"
      },
      {
        id: 106,
        name: "Kota - Chicken",
        description: "Quarter loaf with chips, fried chicken, cheese & sauce",
        price: 65.00,
        image: "https://images.unsplash.com/photo-1586190848861-99aa4a171e90?w=400",
        category: "Kota"
      },
      {
        id: 107,
        name: "Gatsby - Steak",
        description: "Long roll with steak, chips, salad & sauces",
        price: 85.00,
        image: "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=400",
        category: "Gatsby"
      },
      {
        id: 108,
        name: "Gatsby - Chicken",
        description: "Long roll with fried chicken, chips, salad & sauces",
        price: 75.00,
        image: "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=400",
        category: "Gatsby"
      },
      {
        id: 109,
        name: "Vetkoek & Mince",
        description: "Fried dough filled with curried mince",
        price: 35.00,
        image: "https://images.unsplash.com/photo-1612182062366-86893c65d589?w=400",
        category: "Vetkoek"
      },
      {
        id: 110,
        name: "Vetkoek & Cheese",
        description: "Fried dough with melted cheese filling",
        price: 30.00,
        image: "https://images.unsplash.com/photo-1612182062366-86893c65d589?w=400",
        category: "Vetkoek"
      },
      {
        id: 111,
        name: "Vetkoek & Jam",
        description: "Sweet fried dough with strawberry jam",
        price: 25.00,
        image: "https://images.unsplash.com/photo-1612182062366-86893c65d589?w=400",
        category: "Vetkoek"
      },
      {
        id: 112,
        name: "Pap & Vleis",
        description: "Traditional maize porridge with grilled meat & chakalaka",
        price: 70.00,
        image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=400",
        category: "Traditional"
      },
      {
        id: 113,
        name: "Boerewors Roll",
        description: "Grilled boerewors in fresh roll with tomato & onion",
        price: 40.00,
        image: "https://images.unsplash.com/photo-1592415486689-125cbbfcbee2?w=400",
        category: "Traditional"
      },
      {
        id: 114,
        name: "Chips & Cheese",
        description: "Golden fries topped with melted cheese",
        price: 35.00,
        image: "https://images.unsplash.com/photo-1630384082028-8e8cbb0e3c00?w=400",
        category: "Sides"
      },
      {
        id: 115,
        name: "Achar Side",
        description: "Spicy pickled vegetable relish",
        price: 15.00,
        image: "https://images.unsplash.com/photo-1596797038530-2c107229654b?w=400",
        category: "Sides"
      }
    ]
  },
  {
    id: "ocean-basket-style",
    name: "Fresh Catch Seafood",
    cuisine: "Seafood & Fish",
    rating: 4.5,
    reviewCount: 298,
    deliveryTime: "30-40 min",
    deliveryFee: 25,
    image: "https://images.unsplash.com/photo-1615141982883-c7ad0e69fd62?w=400&fm=webp&q=50",
    isOpen: true,
    description: "Fresh seafood daily. From grilled fish to calamari, we bring the ocean to you.",
    address: "Umhlanga, Durban",
    phone: "+27 XX XXX XXXX",
    menuItems: [
      {
        id: 301,
        name: "Hake & Chips",
        description: "Crispy battered hake with hand-cut chips",
        price: 85.00,
        image: "https://images.unsplash.com/photo-1580217593608-61931cefc821?w=400",
        category: "Fish"
      },
      {
        id: 302,
        name: "Grilled Linefish",
        description: "Daily fresh linefish grilled with lemon butter",
        price: 125.00,
        image: "https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=400",
        category: "Fish"
      },
      {
        id: 303,
        name: "Calamari Strips",
        description: "Tender calamari strips with tartare sauce",
        price: 95.00,
        image: "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=400",
        category: "Calamari"
      },
      {
        id: 304,
        name: "Grilled Calamari",
        description: "Whole grilled calamari with garlic butter",
        price: 110.00,
        image: "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=400",
        category: "Calamari"
      },
      {
        id: 305,
        name: "Prawn Curry",
        description: "Creamy prawn curry with rice",
        price: 145.00,
        image: "https://images.unsplash.com/photo-1633321702518-596e62d40e4b?w=400",
        category: "Prawns"
      },
      {
        id: 306,
        name: "Grilled Prawns",
        description: "Flame-grilled prawns with peri-peri sauce",
        price: 155.00,
        image: "https://images.unsplash.com/photo-1565680018434-b513d5e5fd47?w=400",
        category: "Prawns"
      },
      {
        id: 307,
        name: "Seafood Platter for 2",
        description: "Hake, calamari, prawns, mussels & chips",
        price: 320.00,
        image: "https://images.unsplash.com/photo-1615141982883-c7ad0e69fd62?w=400",
        category: "Platters"
      },
      {
        id: 308,
        name: "Fish Burger",
        description: "Crispy fish fillet in bun with tartare sauce",
        price: 70.00,
        image: "https://images.unsplash.com/photo-1625869016774-3a92be2ae2cd?w=400",
        category: "Burgers"
      },
      {
        id: 309,
        name: "Rice",
        description: "Steamed basmati rice",
        price: 25.00,
        image: "https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=400",
        category: "Sides"
      },
      {
        id: 310,
        name: "Garden Salad",
        description: "Fresh mixed salad with vinaigrette",
        price: 35.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/salads.jpg",
        category: "Sides"
      }
    ]
  },
  {
    id: "engen-garage-joburg",
    name: "Engen Garage - Johannesburg",
    cuisine: "Convenience Store",
    rating: 4.3,
    reviewCount: 156,
    deliveryTime: "15-25 min",
    deliveryFee: 12,
    image: "/images/engen-storefront.webp",
    isOpen: true,
    description: "24/7 convenience store offering snacks, drinks, ready-made meals and essentials.",
    address: "Braamfontein, Johannesburg",
    phone: "+27 11 XXX XXXX",
    menuItems: [
      {
        id: 401,
        name: "Chicken Pie",
        description: "Hot freshly baked chicken pie",
        price: 25.00,
        image: "/images/meat-pie.jpg",
        category: "Hot Food"
      },
      {
        id: 402,
        name: "Steak Pie",
        description: "Hot freshly baked steak pie",
        price: 28.00,
        image: "/images/meat-pie.jpg",
        category: "Hot Food"
      },
      {
        id: 403,
        name: "Sausage Roll",
        description: "Warm sausage roll",
        price: 20.00,
        image: "/images/sausage-roll.jpg",
        category: "Hot Food"
      },
      {
        id: 404,
        name: "Boerewors Roll",
        description: "Grilled boerewors in a roll",
        price: 35.00,
        image: "https://images.unsplash.com/photo-1592415486689-125cbbfcbee2?w=400",
        category: "Hot Food"
      },
      {
        id: 405,
        name: "Coca-Cola 500ml",
        description: "Ice cold Coca-Cola",
        price: 18.00,
        image: "/images/coca-cola.jpg",
        category: "Beverages"
      },
      {
        id: 406,
        name: "Energy Drink",
        description: "Red Bull or Monster 500ml",
        price: 35.00,
        image: "/images/energy-drink.jpg",
        category: "Beverages"
      },
      {
        id: 407,
        name: "Bottled Water 500ml",
        description: "Still mineral water",
        price: 12.00,
        image: "/images/bottled-water.jpg",
        category: "Beverages"
      },
      {
        id: 408,
        name: "Coffee",
        description: "Fresh brewed cappuccino or americano",
        price: 22.00,
        image: "/images/coffee-cup.jpg",
        category: "Beverages"
      },
      {
        id: 409,
        name: "Simba Chips",
        description: "Various flavors available",
        price: 15.00,
        image: "/images/potato-chips.jpg",
        category: "Snacks"
      },
      {
        id: 410,
        name: "Chocolate Bar",
        description: "Assorted chocolate bars",
        price: 18.00,
        image: "/images/chocolate-bars.jpg",
        category: "Snacks"
      }
    ]
  },
  {
    id: "engen-garage-durban",
    name: "Engen Garage - Durban",
    cuisine: "Convenience Store",
    rating: 4.4,
    reviewCount: 203,
    deliveryTime: "15-25 min",
    deliveryFee: 12,
    image: "/images/engen-storefront.webp",
    isOpen: true,
    description: "24/7 convenience store offering snacks, drinks, ready-made meals and essentials.",
    address: "Point Road, Durban",
    phone: "+27 31 XXX XXXX",
    menuItems: [
      {
        id: 411,
        name: "Chicken Pie",
        description: "Hot freshly baked chicken pie",
        price: 25.00,
        image: "/images/meat-pie.jpg",
        category: "Hot Food"
      },
      {
        id: 412,
        name: "Steak Pie",
        description: "Hot freshly baked steak pie",
        price: 28.00,
        image: "/images/meat-pie.jpg",
        category: "Hot Food"
      },
      {
        id: 413,
        name: "Sausage Roll",
        description: "Warm sausage roll",
        price: 20.00,
        image: "/images/sausage-roll.jpg",
        category: "Hot Food"
      },
      {
        id: 414,
        name: "Bunny Chow - Bean",
        description: "Quarter loaf with bean curry",
        price: 40.00,
        image: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400",
        category: "Hot Food"
      },
      {
        id: 415,
        name: "Coca-Cola 500ml",
        description: "Ice cold Coca-Cola",
        price: 18.00,
        image: "/images/coca-cola.jpg",
        category: "Beverages"
      },
      {
        id: 416,
        name: "Energy Drink",
        description: "Red Bull or Monster 500ml",
        price: 35.00,
        image: "/images/energy-drink.jpg",
        category: "Beverages"
      },
      {
        id: 417,
        name: "Bottled Water 500ml",
        description: "Still mineral water",
        price: 12.00,
        image: "/images/bottled-water.jpg",
        category: "Beverages"
      },
      {
        id: 418,
        name: "Iced Coffee",
        description: "Cold brew coffee with ice",
        price: 25.00,
        image: "/images/coffee-cup.jpg",
        category: "Beverages"
      },
      {
        id: 419,
        name: "Chips & Snacks",
        description: "Various flavors available",
        price: 15.00,
        image: "/images/potato-chips.jpg",
        category: "Snacks"
      },
      {
        id: 420,
        name: "Biltong Pack",
        description: "100g beef biltong",
        price: 55.00,
        image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=400",
        category: "Snacks"
      }
    ]
  },
  {
    id: "astron-garage-joburg",
    name: "Astron Garage - Johannesburg",
    cuisine: "Convenience Store",
    rating: 4.2,
    reviewCount: 134,
    deliveryTime: "15-25 min",
    deliveryFee: 12,
    image: "/images/astron-storefront.webp",
    isOpen: true,
    description: "Your neighborhood garage shop with fresh food, snacks and daily essentials.",
    address: "Roodepoort, Johannesburg",
    phone: "+27 11 XXX XXXX",
    menuItems: [
      {
        id: 501,
        name: "Gatsby - Polony",
        description: "Half loaf with polony, chips and sauce",
        price: 50.00,
        image: "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=400",
        category: "Hot Food"
      },
      {
        id: 502,
        name: "Samoosa - 4pc",
        description: "Four vegetable samoosas",
        price: 20.00,
        image: "/images/samoosa.jpg",
        category: "Hot Food"
      },
      {
        id: 503,
        name: "Chicken Wrap",
        description: "Grilled chicken wrap with salad",
        price: 45.00,
        image: "/images/wrap-sandwich.jpg",
        category: "Hot Food"
      },
      {
        id: 504,
        name: "Chips",
        description: "Hot crispy chips",
        price: 18.00,
        image: "/images/potato-chips.jpg",
        category: "Hot Food"
      },
      {
        id: 505,
        name: "Stoney Ginger Beer 500ml",
        description: "Ice cold ginger beer",
        price: 18.00,
        image: "/images/coca-cola.jpg",
        category: "Beverages"
      },
      {
        id: 506,
        name: "Fruit Juice 500ml",
        description: "Assorted flavors",
        price: 20.00,
        image: "/images/fruit-juice.jpg",
        category: "Beverages"
      },
      {
        id: 507,
        name: "Iced Tea",
        description: "Peach or lemon iced tea",
        price: 18.00,
        image: "/images/iced-tea.jpg",
        category: "Beverages"
      },
      {
        id: 508,
        name: "Milkshake",
        description: "Chocolate, vanilla or strawberry",
        price: 28.00,
        image: "/images/milkshake.jpg",
        category: "Beverages"
      },
      {
        id: 509,
        name: "Peanuts & Nuts",
        description: "Salted or honey roasted",
        price: 22.00,
        image: "/images/peanuts-nuts.jpg",
        category: "Snacks"
      },
      {
        id: 510,
        name: "Chappies Gum",
        description: "Assorted bubble gum",
        price: 5.00,
        image: "/images/snack-chips.jpg",
        category: "Snacks"
      }
    ]
  },
  {
    id: "astron-garage-durban",
    name: "Astron Garage - Durban",
    cuisine: "Convenience Store",
    rating: 4.3,
    reviewCount: 178,
    deliveryTime: "15-25 min",
    deliveryFee: 12,
    image: "/images/astron-storefront.webp",
    isOpen: true,
    description: "Your neighborhood garage shop with fresh food, snacks and daily essentials.",
    address: "Morningside, Durban",
    phone: "+27 31 XXX XXXX",
    menuItems: [
      {
        id: 511,
        name: "Bunny Chow - Chicken",
        description: "Quarter loaf with chicken curry",
        price: 50.00,
        image: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400",
        category: "Hot Food"
      },
      {
        id: 512,
        name: "Samoosa - 6pc",
        description: "Six chicken or beef samoosas",
        price: 30.00,
        image: "/images/samoosa.jpg",
        category: "Hot Food"
      },
      {
        id: 513,
        name: "Burger",
        description: "Beef burger with cheese",
        price: 45.00,
        image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400",
        category: "Hot Food"
      },
      {
        id: 514,
        name: "Spring Rolls - 4pc",
        description: "Four crispy spring rolls",
        price: 25.00,
        image: "/images/samoosa.jpg",
        category: "Hot Food"
      },
      {
        id: 515,
        name: "Coke or Fanta 500ml",
        description: "Ice cold soft drink",
        price: 18.00,
        image: "/images/coca-cola.jpg",
        category: "Beverages"
      },
      {
        id: 516,
        name: "Fresh Milk 1L",
        description: "Full cream or low fat",
        price: 22.00,
        image: "/images/bottled-water.jpg",
        category: "Beverages"
      },
      {
        id: 517,
        name: "Sports Drink",
        description: "PowerAde or Energade",
        price: 20.00,
        image: "/images/energy-drink.jpg",
        category: "Beverages"
      },
      {
        id: 518,
        name: "Smoothie",
        description: "Mixed berry or mango",
        price: 32.00,
        image: "/images/milkshake.jpg",
        category: "Beverages"
      },
      {
        id: 519,
        name: "Chocolate Slab",
        description: "150g chocolate bar",
        price: 25.00,
        image: "/images/chocolate-bars.jpg",
        category: "Snacks"
      },
      {
        id: 520,
        name: "Droewors",
        description: "50g dried sausage",
        price: 35.00,
        image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=400",
        category: "Snacks"
      }
    ]
  },
  {
    id: "shell-garage-joburg",
    name: "Shell Garage - Johannesburg",
    cuisine: "Convenience Store",
    rating: 4.5,
    reviewCount: 289,
    deliveryTime: "15-25 min",
    deliveryFee: 12,
    image: "/images/shell-storefront.webp",
    isOpen: true,
    description: "Premium convenience store with Deli2Go fresh food and wide range of products.",
    address: "Sandton City, Johannesburg",
    phone: "+27 11 XXX XXXX",
    menuItems: [
      {
        id: 601,
        name: "Deli2Go Wrap",
        description: "Fresh chicken or beef wrap",
        price: 48.00,
        image: "/images/wrap-sandwich.jpg",
        category: "Hot Food"
      },
      {
        id: 602,
        name: "Toasted Sandwich",
        description: "Cheese, ham & tomato toasted",
        price: 35.00,
        image: "/images/toasted-sandwich.jpg",
        category: "Hot Food"
      },
      {
        id: 603,
        name: "Hot Dog",
        description: "Grilled hot dog in a bun",
        price: 30.00,
        image: "/images/hot-dog.jpg",
        category: "Hot Food"
      },
      {
        id: 604,
        name: "Chicken Mayo Roll",
        description: "Fresh chicken mayo in a roll",
        price: 40.00,
        image: "/images/wrap-sandwich.jpg",
        category: "Hot Food"
      },
      {
        id: 605,
        name: "Cappuccino",
        description: "Freshly brewed cappuccino",
        price: 25.00,
        image: "/images/coffee-cup.jpg",
        category: "Beverages"
      },
      {
        id: 606,
        name: "Pepsi 500ml",
        description: "Ice cold Pepsi",
        price: 18.00,
        image: "/images/coca-cola.jpg",
        category: "Beverages"
      },
      {
        id: 607,
        name: "Red Bull 250ml",
        description: "Energy drink",
        price: 30.00,
        image: "/images/energy-drink.jpg",
        category: "Beverages"
      },
      {
        id: 608,
        name: "Flavored Water",
        description: "Various flavors 500ml",
        price: 16.00,
        image: "/images/bottled-water.jpg",
        category: "Beverages"
      },
      {
        id: 609,
        name: "Lays Chips",
        description: "Various flavors",
        price: 16.00,
        image: "/images/potato-chips.jpg",
        category: "Snacks"
      },
      {
        id: 610,
        name: "Protein Bar",
        description: "Various flavors",
        price: 28.00,
        image: "/images/energy-bar.jpg",
        category: "Snacks"
      }
    ]
  },
  {
    id: "shell-garage-durban",
    name: "Shell Garage - Durban",
    cuisine: "Convenience Store",
    rating: 4.4,
    reviewCount: 245,
    deliveryTime: "15-25 min",
    deliveryFee: 12,
    image: "/images/shell-storefront.webp",
    isOpen: true,
    description: "Premium convenience store with Deli2Go fresh food and wide range of products.",
    address: "Umhlanga Rocks, Durban",
    phone: "+27 31 XXX XXXX",
    menuItems: [
      {
        id: 611,
        name: "Deli2Go Sandwich",
        description: "Fresh chicken or tuna sandwich",
        price: 42.00,
        image: "/images/toasted-sandwich.jpg",
        category: "Hot Food"
      },
      {
        id: 612,
        name: "Pie & Chips Combo",
        description: "Steak pie with chips",
        price: 45.00,
        image: "/images/meat-pie.jpg",
        category: "Hot Food"
      },
      {
        id: 613,
        name: "Chicken Burger",
        description: "Crispy chicken burger",
        price: 50.00,
        image: "https://images.unsplash.com/photo-1562447197-0673bb2ea4a5?w=400",
        category: "Hot Food"
      },
      {
        id: 614,
        name: "Vetkoek & Mince",
        description: "Traditional vetkoek with mince",
        price: 32.00,
        image: "https://images.unsplash.com/photo-1612182062366-86893c65d589?w=400",
        category: "Hot Food"
      },
      {
        id: 615,
        name: "Latte",
        description: "Freshly brewed latte",
        price: 26.00,
        image: "/images/coffee-cup.jpg",
        category: "Beverages"
      },
      {
        id: 616,
        name: "Appletiser 330ml",
        description: "Sparkling apple juice",
        price: 20.00,
        image: "/images/fruit-juice.jpg",
        category: "Beverages"
      },
      {
        id: 617,
        name: "Monster Energy 500ml",
        description: "Energy drink",
        price: 35.00,
        image: "/images/energy-drink.jpg",
        category: "Beverages"
      },
      {
        id: 618,
        name: "Fruit Juice 1L",
        description: "Orange or apple juice",
        price: 28.00,
        image: "/images/fruit-juice.jpg",
        category: "Beverages"
      },
      {
        id: 619,
        name: "Snack Pack",
        description: "Mixed nuts and dried fruit",
        price: 30.00,
        image: "/images/peanuts-nuts.jpg",
        category: "Snacks"
      },
      {
        id: 620,
        name: "Biltong 100g",
        description: "Premium beef biltong",
        price: 60.00,
        image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=400",
        category: "Snacks"
      }
    ]
  },
  {
    id: "mnandi-eats",
    name: "Mnandi Eats",
    cuisine: "South African Comfort Food",
    rating: 4.7,
    reviewCount: 412,
    deliveryTime: "30-40 min",
    deliveryFee: 18,
    image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=400&fm=webp&q=50",
    isOpen: true,
    description: "Authentic township flavors and home-cooked meals delivered hot to your door.",
    address: "Johannesburg, South Africa",
    phone: "+27 11 XXX XXXX",
    menuItems: [
      {
        id: 701,
        name: "Pap, Wors & Chakalaka",
        description: "Traditional pap with boerewors and spicy chakalaka",
        price: 65.00,
        image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=400",
        category: "Mains"
      },
      {
        id: 702,
        name: "Chicken Stew & Dumplings",
        description: "Slow-cooked chicken stew with dombolo",
        price: 75.00,
        image: "https://www.mnandibraai.co.za/assets/img/menu/chicken-stew.jpg",
        category: "Mains"
      },
      {
        id: 703,
        name: "Beef Tripe & Pap",
        description: "Traditional mogodu with maize porridge",
        price: 70.00,
        image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=400",
        category: "Mains"
      },
      {
        id: 704,
        name: "Umfino (Wild Spinach)",
        description: "Traditional greens with peanut butter",
        price: 45.00,
        image: "https://images.unsplash.com/photo-1576045057995-568f588f82fb?w=400",
        category: "Sides"
      },
      {
        id: 705,
        name: "Amagwinya (Vetkoek)",
        description: "Fried dough with mince or cheese",
        price: 35.00,
        image: "https://images.unsplash.com/photo-1612182062366-86893c65d589?w=400",
        category: "Snacks"
      }
    ]
  },
  {
    id: "andiccio24",
    name: "Andiccio24",
    cuisine: "Italian Cuisine",
    rating: 4.6,
    reviewCount: 389,
    deliveryTime: "35-45 min",
    deliveryFee: 22,
    image: "/images/andiccio24-storefront.webp",
    isOpen: true,
    description: "Authentic Italian pizzas, pastas and more. Quality ingredients, traditional recipes.",
    address: "Sandton, Johannesburg",
    phone: "+27 11 XXX XXXX",
    menuItems: [
      {
        id: 801,
        name: "Margherita Pizza",
        description: "Classic tomato, mozzarella, basil",
        price: 95.00,
        image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400",
        category: "Pizza"
      },
      {
        id: 802,
        name: "Pepperoni Pizza",
        description: "Tomato, mozzarella, pepperoni",
        price: 110.00,
        image: "https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400",
        category: "Pizza"
      },
      {
        id: 803,
        name: "Four Seasons Pizza",
        description: "Artichokes, ham, mushrooms, olives",
        price: 125.00,
        image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400",
        category: "Pizza"
      },
      {
        id: 804,
        name: "Spaghetti Carbonara",
        description: "Creamy bacon and egg pasta",
        price: 95.00,
        image: "https://images.unsplash.com/photo-1612874742237-6526221588e3?w=400",
        category: "Pasta"
      },
      {
        id: 805,
        name: "Penne Arrabbiata",
        description: "Spicy tomato pasta",
        price: 85.00,
        image: "https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=400",
        category: "Pasta"
      },
      {
        id: 806,
        name: "Tiramisu",
        description: "Classic Italian dessert",
        price: 55.00,
        image: "https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=400",
        category: "Desserts"
      }
    ]
  },
  {
    id: "market-kokoro",
    name: "Market Kokoro",
    cuisine: "Japanese Fusion",
    rating: 4.8,
    reviewCount: 456,
    deliveryTime: "40-50 min",
    deliveryFee: 25,
    image: "/images/market-kokoro-storefront.webp",
    isOpen: true,
    description: "Contemporary Japanese cuisine with a modern twist. Fresh sushi, ramen and more.",
    address: "Rosebank, Johannesburg",
    phone: "+27 11 XXX XXXX",
    menuItems: [
      {
        id: 901,
        name: "California Roll",
        description: "Crab, avocado, cucumber",
        price: 85.00,
        image: "https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=400",
        category: "Sushi"
      },
      {
        id: 902,
        name: "Salmon Fashion Sandwich",
        description: "Salmon, avocado, cream cheese",
        price: 95.00,
        image: "https://images.unsplash.com/photo-1617196034796-73dfa7b1fd56?w=400",
        category: "Sushi"
      },
      {
        id: 903,
        name: "Spicy Tuna Roll",
        description: "Tuna, spicy mayo, spring onion",
        price: 90.00,
        image: "https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=400",
        category: "Sushi"
      },
      {
        id: 904,
        name: "Tonkotsu Ramen",
        description: "Rich pork bone broth with noodles",
        price: 110.00,
        image: "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=400",
        category: "Ramen"
      },
      {
        id: 905,
        name: "Chicken Katsu Curry",
        description: "Breaded chicken with Japanese curry",
        price: 105.00,
        image: "https://images.unsplash.com/photo-1631084655463-e671365ec05f?w=400",
        category: "Mains"
      },
      {
        id: 906,
        name: "Gyoza (6pc)",
        description: "Pan-fried pork dumplings",
        price: 65.00,
        image: "https://images.unsplash.com/photo-1626804475297-41608ea09aeb?w=400",
        category: "Appetizers"
      }
    ]
  },
  {
    id: "simply-asia",
    name: "Simply Asia",
    cuisine: "Asian Fusion",
    rating: 4.5,
    reviewCount: 523,
    deliveryTime: "30-40 min",
    deliveryFee: 20,
    image: "/images/simply-asia-storefront.webp",
    isOpen: true,
    description: "Fresh Asian flavors with wok-tossed noodles, curries and spring rolls.",
    address: "Sandton City, Johannesburg",
    phone: "+27 11 XXX XXXX",
    menuItems: [
      {
        id: 1001,
        name: "Pad Thai",
        description: "Classic Thai rice noodles with peanuts",
        price: 95.00,
        image: "https://images.unsplash.com/photo-1626074353765-517a681e40be?w=400",
        category: "Noodles"
      },
      {
        id: 1002,
        name: "Singapore Noodles",
        description: "Curry-spiced vermicelli with veggies",
        price: 90.00,
        image: "https://images.unsplash.com/photo-1585032226651-759b368d7246?w=400",
        category: "Noodles"
      },
      {
        id: 1003,
        name: "Green Thai Curry",
        description: "Coconut curry with vegetables",
        price: 100.00,
        image: "https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?w=400",
        category: "Curries"
      },
      {
        id: 1004,
        name: "Spring Rolls (4pc)",
        description: "Crispy vegetable spring rolls",
        price: 45.00,
        image: "https://images.unsplash.com/photo-1625950233268-6dde9bf68c1c?w=400",
        category: "Starters"
      },
      {
        id: 1005,
        name: "Chicken Satay",
        description: "Grilled chicken skewers with peanut sauce",
        price: 85.00,
        image: "https://images.unsplash.com/photo-1529563021893-cc83c992d75d?w=400",
        category: "Starters"
      },
      {
        id: 1006,
        name: "Fried Rice",
        description: "Egg fried rice with vegetables",
        price: 75.00,
        image: "https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=400",
        category: "Rice"
      }
    ]
  },
  {
    id: "melrose-nursery",
    name: "Melrose Nursery",
    cuisine: "Plants & Garden",
    rating: 4.9,
    reviewCount: 234,
    deliveryTime: "60-90 min",
    deliveryFee: 30,
    image: "https://images.unsplash.com/photo-1466781783364-36c955e42a7f?w=400&fm=webp&q=50",
    isOpen: true,
    description: "Premium plants, succulents, and gardening essentials delivered to your door.",
    address: "Melrose, Johannesburg",
    phone: "+27 11 XXX XXXX",
    menuItems: [
      {
        id: 1101,
        name: "Monstera Deliciosa",
        description: "Large indoor tropical plant",
        price: 350.00,
        image: "https://images.unsplash.com/photo-1545241047-6083a3684587?w=400",
        category: "Indoor Plants"
      },
      {
        id: 1102,
        name: "Snake Plant",
        description: "Low maintenance air purifier",
        price: 180.00,
        image: "https://images.unsplash.com/photo-1593482892540-73c9239d9f0d?w=400",
        category: "Indoor Plants"
      },
      {
        id: 1103,
        name: "Succulent Mix (5 pack)",
        description: "Assorted small succulents",
        price: 120.00,
        image: "https://images.unsplash.com/photo-1459156212016-c812468e2115?w=400",
        category: "Succulents"
      },
      {
        id: 1104,
        name: "Fiddle Leaf Fig",
        description: "Statement indoor tree",
        price: 450.00,
        image: "https://images.unsplash.com/photo-1614594975525-e45190c55d0b?w=400",
        category: "Indoor Plants"
      },
      {
        id: 1105,
        name: "Potting Mix 10L",
        description: "Premium potting soil",
        price: 85.00,
        image: "https://images.unsplash.com/photo-1466781783364-36c955e42a7f?w=400",
        category: "Gardening"
      },
      {
        id: 1106,
        name: "Ceramic Pot Set",
        description: "3 decorative pots with drainage",
        price: 220.00,
        image: "https://images.unsplash.com/photo-1485955900006-10f4d324d411?w=400",
        category: "Accessories"
      }
    ]
  },
  {
    id: "420-cartel",
    name: "420 Cartel",
    cuisine: "Cannabis & Wellness",
    rating: 4.7,
    reviewCount: 187,
    deliveryTime: "45-60 min",
    deliveryFee: 25,
    image: "/images/420-cartel-storefront.webp",
    isOpen: true,
    description: "Premium cannabis products and wellness accessories. Legal and licensed.",
    address: "Johannesburg, South Africa",
    phone: "+27 11 XXX XXXX",
    menuItems: [
      {
        id: 1201,
        name: "CBD Oil 30ml",
        description: "Full spectrum CBD oil",
        price: 450.00,
        image: "https://images.unsplash.com/photo-1603909192426-c4e4b1c8c3da?w=400",
        category: "CBD Products"
      },
      {
        id: 1202,
        name: "Hemp Flower 5g",
        description: "High CBD, low THC flower",
        price: 280.00,
        image: "https://images.unsplash.com/photo-1566977276921-c29f7094dc98?w=400",
        category: "Flower"
      },
      {
        id: 1203,
        name: "Rolling Papers",
        description: "Premium hemp papers",
        price: 35.00,
        image: "https://images.unsplash.com/photo-1603909192426-c4e4b1c8c3da?w=400",
        category: "Accessories"
      },
      {
        id: 1204,
        name: "Glass Pipe",
        description: "Handcrafted glass piece",
        price: 250.00,
        image: "https://images.unsplash.com/photo-1603909192426-c4e4b1c8c3da?w=400",
        category: "Accessories"
      },
      {
        id: 1205,
        name: "CBD Gummies 20pc",
        description: "25mg CBD per gummy",
        price: 320.00,
        image: "https://images.unsplash.com/photo-1603909192426-c4e4b1c8c3da?w=400",
        category: "Edibles"
      }
    ]
  },
  {
    id: "news-cafe-rivonia",
    name: "News Cafe Rivonia",
    cuisine: "Cafe & Bistro",
    rating: 4.6,
    reviewCount: 612,
    deliveryTime: "30-40 min",
    deliveryFee: 22,
    image: "/images/news-cafe-storefront.webp",
    isOpen: true,
    description: "All-day breakfast, burgers, salads and signature dishes. A South African favorite.",
    address: "Rivonia, Johannesburg",
    phone: "+27 11 XXX XXXX",
    menuItems: [
      {
        id: 1301,
        name: "Full English Breakfast",
        description: "Eggs, bacon, sausage, tomato, toast",
        price: 95.00,
        image: "https://images.unsplash.com/photo-1533089860892-a7c6f0a88666?w=400",
        category: "Breakfast"
      },
      {
        id: 1302,
        name: "News Burger",
        description: "Signature beef burger with all toppings",
        price: 110.00,
        image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400",
        category: "Burgers"
      },
      {
        id: 1303,
        name: "Caesar Salad",
        description: "Cos lettuce, chicken, parmesan, croutons",
        price: 85.00,
        image: "https://images.unsplash.com/photo-1546793665-c74683f339c1?w=400",
        category: "Salads"
      },
      {
        id: 1304,
        name: "Chicken Schnitzel",
        description: "Breaded chicken with chips",
        price: 105.00,
        image: "https://images.unsplash.com/photo-1632778149955-e80f8ceca2e8?w=400",
        category: "Mains"
      },
      {
        id: 1305,
        name: "Cappuccino",
        description: "Freshly brewed coffee",
        price: 32.00,
        image: "https://images.unsplash.com/photo-1572442388796-11668a67e53d?w=400",
        category: "Beverages"
      },
      {
        id: 1306,
        name: "Chocolate Brownie",
        description: "Warm brownie with ice cream",
        price: 65.00,
        image: "https://images.unsplash.com/photo-1607920591413-4ec007e70023?w=400",
        category: "Desserts"
      }
    ]
  },
  {
    id: "mcdonalds",
    name: "McDonald's",
    cuisine: "Fast Food",
    rating: 4.3,
    reviewCount: 1834,
    deliveryTime: "20-30 min",
    deliveryFee: 15,
    image: "/images/mcdonalds-storefront.webp",
    isOpen: true,
    description: "World-famous burgers, fries and more. Consistent quality, fast service.",
    address: "Multiple Locations, South Africa",
    phone: "+27 XX XXX XXXX",
    menuItems: [
      {
        id: 1401,
        name: "Big Mac Meal",
        description: "Big Mac, medium fries, drink",
        price: 75.00,
        image: "https://images.unsplash.com/photo-1553979459-d2229ba7433b?w=400",
        category: "Meals"
      },
      {
        id: 1402,
        name: "Quarter Pounder Meal",
        description: "Quarter Pounder with cheese, fries, drink",
        price: 80.00,
        image: "https://images.unsplash.com/photo-1572802419224-296b0aeee0d9?w=400",
        category: "Meals"
      },
      {
        id: 1403,
        name: "McChicken Meal",
        description: "McChicken burger, fries, drink",
        price: 70.00,
        image: "https://images.unsplash.com/photo-1562447197-0673bb2ea4a5?w=400",
        category: "Meals"
      },
      {
        id: 1404,
        name: "20pc Chicken McNuggets",
        description: "Crispy chicken nuggets with sauces",
        price: 95.00,
        image: "https://images.unsplash.com/photo-1619740455993-32e5c592e9c5?w=400",
        category: "Chicken"
      },
      {
        id: 1405,
        name: "Large Fries",
        description: "World-famous golden fries",
        price: 28.00,
        image: "https://images.unsplash.com/photo-1630384082028-8e8cbb0e3c00?w=400",
        category: "Sides"
      },
      {
        id: 1406,
        name: "McFlurry Oreo",
        description: "Soft serve with Oreo pieces",
        price: 35.00,
        image: "https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=400",
        category: "Desserts"
      }
    ]
  },
  {
    id: "kfc",
    name: "KFC",
    cuisine: "Fried Chicken",
    rating: 4.4,
    reviewCount: 1567,
    deliveryTime: "25-35 min",
    deliveryFee: 18,
    image: "/images/kfc-storefront.webp",
    isOpen: true,
    description: "Finger lickin' good fried chicken. Original Recipe and Hot & Crispy.",
    address: "Multiple Locations, South Africa",
    phone: "+27 XX XXX XXXX",
    menuItems: [
      {
        id: 1501,
        name: "Streetwise Two",
        description: "2pc chicken, chips, roll",
        price: 65.00,
        image: "https://images.unsplash.com/photo-1626645738196-c2a7c87a8f58?w=400",
        category: "Meals"
      },
      {
        id: 1502,
        name: "9pc Bucket",
        description: "9 pieces of chicken",
        price: 180.00,
        image: "https://images.unsplash.com/photo-1626645738196-c2a7c87a8f58?w=400",
        category: "Buckets"
      },
      {
        id: 1503,
        name: "Zinger Burger Meal",
        description: "Spicy zinger burger, chips, drink",
        price: 75.00,
        image: "https://images.unsplash.com/photo-1606755962773-d324e0a13086?w=400",
        category: "Burgers"
      },
      {
        id: 1504,
        name: "Colonel Burger",
        description: "Original recipe fillet burger",
        price: 70.00,
        image: "https://images.unsplash.com/photo-1606755962773-d324e0a13086?w=400",
        category: "Burgers"
      },
      {
        id: 1505,
        name: "6pc Wrapstar",
        description: "6 mini chicken wraps",
        price: 85.00,
        image: "https://images.unsplash.com/photo-1626645738196-c2a7c87a8f58?w=400",
        category: "Wraps"
      },
      {
        id: 1506,
        name: "Coleslaw Large",
        description: "Creamy coleslaw",
        price: 25.00,
        image: "https://images.unsplash.com/photo-1626645738196-c2a7c87a8f58?w=400",
        category: "Sides"
      }
    ]
  },
  {
    id: "steers",
    name: "Steers",
    cuisine: "Burgers & Flame-Grilled",
    rating: 4.5,
    reviewCount: 923,
    deliveryTime: "25-35 min",
    deliveryFee: 18,
    image: "/images/steers-storefront.webp",
    isOpen: true,
    description: "Real flame-grilled burgers with 100% pure beef. A South African institution.",
    address: "Multiple Locations, South Africa",
    phone: "+27 XX XXX XXXX",
    menuItems: [
      {
        id: 1601,
        name: "King Steer Burger",
        description: "Double beef, cheese, all toppings",
        price: 85.00,
        image: "https://images.unsplash.com/photo-1550547660-d9450f859349?w=400",
        category: "Burgers"
      },
      {
        id: 1602,
        name: "Big Steer Burger",
        description: "Single beef patty with all toppings",
        price: 70.00,
        image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400",
        category: "Burgers"
      },
      {
        id: 1603,
        name: "Chicken Burger",
        description: "Flame-grilled chicken breast",
        price: 75.00,
        image: "https://images.unsplash.com/photo-1562447197-0673bb2ea4a5?w=400",
        category: "Burgers"
      },
      {
        id: 1604,
        name: "Ribs & Chips",
        description: "BBQ basted ribs with chips",
        price: 110.00,
        image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=400",
        category: "Ribs"
      },
      {
        id: 1605,
        name: "Chips & Cheese",
        description: "Crispy chips with melted cheese",
        price: 40.00,
        image: "https://images.unsplash.com/photo-1630384082028-8e8cbb0e3c00?w=400",
        category: "Sides"
      },
      {
        id: 1606,
        name: "Soft Serve Ice Cream",
        description: "Classic vanilla soft serve",
        price: 18.00,
        image: "https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=400",
        category: "Desserts"
      }
    ]
  },
  {
    id: "colcacchio",
    name: "Col'Cacchio",
    cuisine: "Artisan Pizzeria",
    rating: 4.7,
    reviewCount: 734,
    deliveryTime: "35-45 min",
    deliveryFee: 22,
    image: "/images/col-cacchio-storefront.webp",
    isOpen: true,
    description: "Hand-stretched pizzas with fresh ingredients. Authentic Italian-style pizzeria.",
    address: "Multiple Locations, South Africa",
    phone: "+27 XX XXX XXXX",
    menuItems: [
      {
        id: 1701,
        name: "Margherita Pizza",
        description: "Tomato, mozzarella, basil",
        price: 105.00,
        image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400",
        category: "Pizza"
      },
      {
        id: 1702,
        name: "Regina Pizza",
        description: "Ham, mushroom, olives",
        price: 125.00,
        image: "https://images.unsplash.com/photo-1571407970349-bc81e7e96a47?w=400",
        category: "Pizza"
      },
      {
        id: 1703,
        name: "Capricciosa Pizza",
        description: "Ham, artichokes, mushrooms, olives",
        price: 135.00,
        image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400",
        category: "Pizza"
      },
      {
        id: 1704,
        name: "Chicken Caesar Salad",
        description: "Grilled chicken, cos lettuce, parmesan",
        price: 95.00,
        image: "https://images.unsplash.com/photo-1546793665-c74683f339c1?w=400",
        category: "Salads"
      },
      {
        id: 1705,
        name: "Penne Arrabiata",
        description: "Spicy tomato pasta",
        price: 90.00,
        image: "https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=400",
        category: "Pasta"
      },
      {
        id: 1706,
        name: "Chocolate Fondant",
        description: "Molten chocolate cake",
        price: 70.00,
        image: "https://images.unsplash.com/photo-1607920591413-4ec007e70023?w=400",
        category: "Desserts"
      }
    ]
  },
  {
    id: "pantry",
    name: "Pantry",
    cuisine: "Gourmet Deli",
    rating: 4.8,
    reviewCount: 445,
    deliveryTime: "30-40 min",
    deliveryFee: 20,
    image: "/images/pantry-storefront.webp",
    isOpen: true,
    description: "Gourmet sandwiches, salads, and artisan coffee. Fresh ingredients, creative flavors.",
    address: "Parkhurst, Johannesburg",
    phone: "+27 11 XXX XXXX",
    menuItems: [
      {
        id: 1801,
        name: "Smoked Salmon Bagel",
        description: "Salmon, cream cheese, capers, red onion",
        price: 95.00,
        image: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=400",
        category: "Sandwiches"
      },
      {
        id: 1802,
        name: "Chicken Pesto Sandwich",
        description: "Grilled chicken, pesto, mozzarella",
        price: 85.00,
        image: "https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400",
        category: "Sandwiches"
      },
      {
        id: 1803,
        name: "Greek Salad Bowl",
        description: "Feta, olives, cucumber, tomato",
        price: 80.00,
        image: "https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=400",
        category: "Salads"
      },
      {
        id: 1804,
        name: "Quinoa Buddha Bowl",
        description: "Quinoa, avocado, chickpeas, tahini",
        price: 95.00,
        image: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400",
        category: "Salads"
      },
      {
        id: 1805,
        name: "Flat White",
        description: "Artisan coffee with microfoam",
        price: 38.00,
        image: "https://images.unsplash.com/photo-1572442388796-11668a67e53d?w=400",
        category: "Beverages"
      },
      {
        id: 1806,
        name: "Carrot Cake",
        description: "Homemade with cream cheese frosting",
        price: 55.00,
        image: "https://images.unsplash.com/photo-1621303837174-89787a7d4729?w=400",
        category: "Desserts"
      }
    ]
  }
];

export function getStoreById(id: string): Store | undefined {
  return stores.find((store) => store.id === id);
}

// Legacy exports for backward compatibility
export const restaurants = stores;
export const getRestaurantById = getStoreById;
export type Restaurant = Store;
